// Keep administrator aliases aligned with UserAdministrationAuthorization.
const reviewContributorRoles = new Set([
  "qm", "quality manager", "inspection team", "inspection member", "inspection team member",
  "admin", "administrator", "system admin", "system administrator", "piers admin", "piers administrator",
  "firm admin", "firm administrator", "account/firm admin", "account/firm administrator",
]);

export function canContributeToReview(account) {
  const role = account?.role?.name || account?.roleName || account?.userRole?.name || "";
  return reviewContributorRoles.has(String(role).trim().toLowerCase());
}

export function isReviewAdministrator(account) {
  const role = account?.role?.name || account?.roleName || account?.userRole?.name || "";
  return /^(admin|administrator|system admin|system administrator|piers admin|piers administrator|firm admin|firm administrator|account\/firm admin|account\/firm administrator)$/i.test(String(role).trim());
}
